import React, { useEffect, useState } from "react";
import { useDocumentTitle } from "../../hooks/customDocumentTitleHook";
import { can_visit, getPractice, getSecureData,  setSecureData } from "../../helpers";
import { getMeasures } from "../../services/caregaps";
import Spacing from "../Spacing";
import { Megaphone } from "lucide-react";
import { fetchMessageTemplate } from "../../services/message";
import AllSchedulers from "./Admin/AllSchedulers";
import { loadAllSchedulers } from "../../services/users";
import { fetchInsuranceGroup } from "../../services/insurance";
import CreateNewCampaignModal from "../Modal/CreateNewCampaignModal";

export default function SchedulerSetup({selectedPracticeChange, fetchChangePracticeData}) {
  let account_id = getPractice("account_id");
  let location_id = getPractice("location_id");
  if (selectedPracticeChange != null && fetchChangePracticeData) {
    account_id = selectedPracticeChange?.account_id;
    location_id = selectedPracticeChange?.location_id;
  }

  const [activeSchedulerTab, setActiveSchedulerTab] = useState(0);
  const [insuranceOptions, setInsuranceOptions] = useState([]);
  const [selectedInsuranceOptions, setSelectedInsuranceOptions] = useState([]);
  const [isTargetPatient, setisTargetPatient] = useState(1);
  const [caregapOptions, setCaregapOptions] = useState([]);
  const [selectedMeasures, setSelectedMeasures] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [templateMessage, setTemplateMessage] = useState("");

  const [templateFilter, setTemplateFilter] = useState({
    page: 1,
    per_page: 100000,
    search_term: "",
    template_type: "",
    title: "",
    order_by: [],
  });
  const defaultValues = {
    account_id: account_id,
    location_id: location_id,
    campaign_name: "",
    insurance_ids: [],
    target_patient_type: "high_risk",
    care_gaps:[],
    message_body: "",
    message_send_type: "now",
    msg_later_datetime: "",
    regular_msg_frequency: "",
    regular_msg_frequency_day: "",
    regular_msg_frequency_time: ""
  };
  const [schedulerForm, setSchedulerForm] = useState(defaultValues);
  const [schedulerLoader, setSchedulerLoader] = useState(false);
  const [schedulerData, setSchedulerData] = useState([]);
  const [openNewScheduler, setOpenNewScheduler] = useState(false);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);

  const loadSchedulers = async (accountId, locationId) => {
    setSchedulerLoader(true);
    try {
      const response = await loadAllSchedulers(accountId, locationId);

      if(response){
        if(!response?.detail && response?.data?.status === "success") {
          setSchedulerData(response?.data?.results);
        } else {
          setActiveSchedulerTab(0);
          setSchedulerData([]);
          console.log("🚀 ~ loadSchedulers ~ error:", response?.data?.message);
        }
      }
    } catch (error) {
      setActiveSchedulerTab(0);
      setSchedulerData([]);
      // console.log("🚀 ~ loadSchedulers ~ error:", error);
    } finally {
      setSchedulerLoader(false);
    }
  };
  
  useEffect(() => {
    loadSchedulers(account_id, location_id);
  }, [account_id, location_id]);
  
  useEffect(() => {
    setActiveSchedulerTab(0);
    setSchedulerForm(defaultValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account_id]);

  const changeActiveTab = (value) => {
    setActiveSchedulerTab(value);
  }

  const loadInsurance = async () => {
    const response = await fetchInsuranceGroup();
    if (response) {
      setInsuranceOptions(response?.data);
    } else {
      setInsuranceOptions([]);
    }
    
    const _all_care_gaps = await getSecureData("all_care_gaps");
    if (!_all_care_gaps) {
      const response = await getMeasures();
      if (response) {
        setCaregapOptions(response?.data);
        await setSecureData("all_care_gaps", JSON.stringify(response?.data));
      }
    } else {
      setCaregapOptions(_all_care_gaps);
    }

  };

  useEffect(() => {
    loadInsurance();
  }, []);

  const handleQMToggle = (id, active, status) => {
    const index = selectedMeasures.findIndex((measure) => measure.id === id);
    const updatedMeasures = [...selectedMeasures];

    if (active === true) {
      if (index !== -1) {
        updatedMeasures[index].status = status;
      } else {
        updatedMeasures.push({ id, status });
      }
    } else {
      if (index !== -1) {
        updatedMeasures.splice(index, 1);
      }
    }

    setSelectedMeasures(updatedMeasures);
  };

  const handleInsuranceOptionToggle = (name, optionId) => {
    setSelectedInsuranceOptions((prev) =>
      prev.includes(optionId)
        ? prev.filter((id) => id !== optionId)
        : [...prev, optionId]
    );
    setSchedulerForm({
      ...schedulerForm,
      [name]: selectedInsuranceOptions.includes(optionId)
        ? selectedInsuranceOptions.filter((id) => id !== optionId)
        : [...selectedInsuranceOptions, optionId],
    });
  };

  const loadTemplates = async (getTemplateFilter, accountId) => {
    setTemplateFilter(getTemplateFilter);
    const response = await fetchMessageTemplate(getTemplateFilter, accountId);
    if (response) {
      setTemplates(response.data.results);
    }
  };

  useEffect(() => {
    loadTemplates(templateFilter, account_id);
  }, [templateFilter, account_id]);

  const handleSelectedTemplate = (e) => {
    const selectedTitle = e.target.value;
    setSelectedTemplate(selectedTitle);

    const selectedItem = templates.find((item) => item.title === selectedTitle);
    if (selectedItem) {
      setTemplateMessage(selectedItem.body);
    }
  };

  const handleSchedulerInputChange = (input) =>{
    const {name, value } = input.target;
    
    if (name ==="message_body"){
      setTemplateMessage(value);
      setSchedulerForm({...schedulerForm, [name]:value });
    }
    setSchedulerForm({...schedulerForm, [name]:value });
  }

  const handleCareGapsInputChange = (event) => {
    const { name, value, type, checked, dataset } = event.target;

    if (type === "checkbox" && name === "caregaps_id_list") {
      const id = parseInt(value, 10);
  
      setSchedulerForm((prev) => {
        const existingIndex = prev.care_gaps.findIndex((item) => item.id === id);
  
        if (checked) {
          if (existingIndex === -1) {
            return {
              ...prev,
              care_gaps: [...prev.care_gaps, { id, status: "pending" }],
            };
          }
          return prev;
        } else {
          return {
            ...prev,
            care_gaps: prev.care_gaps.filter((item) => item.id !== id),
          };
        }
      });
    }

    else if (name === "status" && dataset.careGapId) {
      const id = parseInt(dataset.careGapId, 10);
      const newStatus = value;
  
      setSchedulerForm((prev) => ({
        ...prev,
        care_gaps: prev.care_gaps.map((item) =>
          item.id === id ? { ...item, status: newStatus } : item
        ),
      }));
    }
    else {
      setSchedulerForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  

  useEffect(() => {
    if(isTargetPatient === 1){
      setSchedulerForm((prev) => ({
        ...prev,
        target_patient_type: "high_risk",
        care_gaps: [],
      }));
    }else if (isTargetPatient === 2){
      setSchedulerForm((prev) => ({
        ...prev,
        target_patient_type:"care_gaps",
      }));
    }
  },[isTargetPatient]);

  useDocumentTitle("Text Pilot");

  return (
    <>
      <div className="setup-scheduler-page" style={{ margin: 0 }}>
        <div className="docpro_page_heading_wrap">
          <h2 className="docpro_page_heading docpro_fs_24 docpro_mb_0">
            Text Pilot
          </h2>
          {schedulerData.length > 0 && (
            <div className="docpro_page_heading_btns">
              {(can_visit("settings") && can_visit("settings_scheduler_setup")) && (
                <button
                  className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn"
                  onClick={() => {
                    setOpenNewScheduler(true);
                    setPreviousScrollPosition(window.scrollY);
                    window.scrollTo(0, 0);
                    changeActiveTab(1);
                  }}
                >
                  <Megaphone width={20} height={20} />
                  <span>Create a campaign</span>
                </button>
              )}
            </div>
          )}
        </div>
        <Spacing lg="10" sm="10" />
        <AllSchedulers 
          schedulerLoader={schedulerLoader}
          schedulerData={schedulerData}
          account_id={account_id}
          location_id={location_id}
          reloadData={loadSchedulers}
          setOpenNewScheduler={setOpenNewScheduler}
          changeActiveTab={changeActiveTab}
          previousScrollPosition={previousScrollPosition}
          setPreviousScrollPosition={setPreviousScrollPosition}
        />
      </div>
      

      {openNewScheduler && (
        <CreateNewCampaignModal
          openModal={openNewScheduler}
          setOpenModal={setOpenNewScheduler}
          account_id={account_id}
          location_id={location_id}
          activeSchedulerTab={activeSchedulerTab}
          setActiveSchedulerTab={setActiveSchedulerTab}
          schedulerForm={schedulerForm}
          changeActiveTab={changeActiveTab}
          handleSchedulerInputChange={handleSchedulerInputChange}
          insuranceOptions={insuranceOptions}
          selectedInsuranceOptions={selectedInsuranceOptions}
          handleInsuranceOptionToggle={handleInsuranceOptionToggle}
          isTargetPatient={isTargetPatient}
          setisTargetPatient={setisTargetPatient}
          caregapOptions={caregapOptions}
          selectedMeasures={selectedMeasures}
          handleQMToggle={handleQMToggle}
          handleCareGapsInputChange={handleCareGapsInputChange}
          selectedTemplate={selectedTemplate}
          handleSelectedTemplate={handleSelectedTemplate}
          templates={templates}
          templateMessage={templateMessage}
          setSchedulerForm={setSchedulerForm}
          defaultValues={defaultValues}
          loadSchedulers={loadSchedulers}
          previousScrollPosition={previousScrollPosition}
        />
      )}
    </>
  );
}
